import React from 'react';
import { css } from 'aphrodite/no-important';
import styles from './AddButton.styles';

const AddButton = props => {
  return (
    <span className={css(styles.base, props.styles)} onClick={props.onClick}>
      +
    </span>
  );
};

export default AddButton;



// WEBPACK FOOTER //
// ./src/components/inputs/addbutton/AddButton.js